import { defineComponent as _defineComponent } from 'vue'
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsOfferDetailConditionsSkeleton',
  setup(__props) {

const { isNarrow } = useMyProjects();

return { __sfc: true,isNarrow }
}

})